import { ConstMap } from '@/utils/ConstMap';

export const SOURCE_SEPERATOR = '%%';

/**
 * SchedulePeriod
 */
export enum SCHEDULE_PERIOD {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
}

export const SchedulePeriodMap = new ConstMap([
  [SCHEDULE_PERIOD.DAILY, 'Daily'],
  [SCHEDULE_PERIOD.WEEKLY, 'Weekly'],
  [SCHEDULE_PERIOD.MONTHLY, 'Monthly'],
]);

export enum LANGUAGE {
  EN = 'en',
  KO = 'ko',
}

export enum WEEKDAY {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}

export const WEEKDAY_MAP = new ConstMap([
  [WEEKDAY.SUNDAY, 'Every Sunday'],
  [WEEKDAY.MONDAY, 'Every Monday'],
  [WEEKDAY.TUESDAY, 'Every Tuesday'],
  [WEEKDAY.WEDNESDAY, 'Every Wednesday'],
  [WEEKDAY.THURSDAY, 'Every Thursday'],
  [WEEKDAY.FRIDAY, 'Every Friday'],
  [WEEKDAY.SATURDAY, 'Every Saturday'],
]);

/**
 * @description
 * date of monthly schedule
 * 1 ~ 28
 */
export const MONTHLY_DAY_ARRAY = Array(28)
  .fill(null)
  .map((_, index) => index + 1);
